import React from 'react'

function ThickLine() {
  return (
    <div className='w-20 h-1 bg-yellow'></div>
  )
}

export default ThickLine